import LegalLayout from "@/components/site/LegalLayout";

export default function Datenschutz() {
  return (
    <LegalLayout eyebrow="Rechtliches" title="Datenschutz­erklärung">
      <section>
        <h2>1. Verantwortlicher</h2>
        <p>
          Verantwortlicher im Sinne der Datenschutz-Grundverordnung (DSGVO) und
          anderer nationaler Datenschutz­gesetze sowie sonstiger datenschutz­rechtlicher
          Bestimmungen ist:
        </p>
        <p>
          Michael Horgas
          <br />
          MHorgasConsult
          <br />
          Loehrsweg 2
          <br />
          20249 Hamburg
          <br />
          Deutschland
          <br />
          Telefon: +49 1525 1678724
          <br />
          E-Mail:{" "}
          <a href="mailto:michaelhorgas@mhorgasconsult.com">
            michaelhorgas@mhorgasconsult.com
          </a>
        </p>
      </section>

      <section>
        <h2>2. Allgemeine Hinweise</h2>
        <p>
          Der Schutz Ihrer persönlichen Daten ist mir ein wichtiges Anliegen. Ich
          behandle Ihre personen­bezogenen Daten vertraulich und entsprechend der
          gesetzlichen Datenschutz­vorschriften (insbesondere DSGVO, BDSG) sowie
          dieser Datenschutz­erklärung.
        </p>
        <p>
          Diese Website lässt sich in der Regel ohne Angabe personen­bezogener Daten
          nutzen. Wenn Sie das Kontakt­formular nutzen, werden Sie auf freiwilliger
          Basis um die Angabe bestimmter Daten gebeten.
        </p>
      </section>

      <section>
        <h2>3. Zugriffsdaten / Server-Logfiles</h2>
        <p>
          Beim Aufruf dieser Website werden durch den Hosting-Provider technisch
          notwendige Daten in sogenannten Server-Logfiles erhoben und gespeichert.
          Dazu gehören:
        </p>
        <ul>
          <li>anonymisierte IP-Adresse</li>
          <li>Datum und Uhrzeit der Anfrage</li>
          <li>aufgerufene Seite / Datei</li>
          <li>übertragene Datenmenge</li>
          <li>Browsertyp und -version</li>
          <li>verwendetes Betriebs­system</li>
          <li>Referrer-URL (zuvor besuchte Seite)</li>
        </ul>
        <p>
          Diese Daten sind nicht bestimmten Personen zuordenbar. Eine Zusammenführung
          mit anderen Datenquellen wird nicht vorgenommen. Rechtsgrundlage ist Art. 6
          Abs. 1 lit. f DSGVO; das berechtigte Interesse besteht in der Sicherheit und
          stabilen Bereitstellung dieser Website.
        </p>
      </section>

      <section>
        <h2>4. Kontaktaufnahme über das Kontakt­formular</h2>
        <p>
          Wenn Sie mir über das Kontakt­formular Anfragen zukommen lassen, werden
          folgende Angaben verarbeitet:
        </p>
        <ul>
          <li>Name</li>
          <li>E-Mail-Adresse</li>
          <li>optional: Unternehmen / Haus, Position, Telefonnummer, Thema</li>
          <li>Ihre Nachricht</li>
          <li>Zeitpunkt der Übermittlung</li>
        </ul>
        <p>
          Die Verarbeitung erfolgt zum Zweck der Bearbeitung Ihrer Anfrage und
          möglicher Anschluss­fragen. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO
          (Anbahnung / Durchführung eines Vertrags­verhältnisses) sowie Art. 6 Abs. 1
          lit. f DSGVO (berechtigtes Interesse an der wirksamen Bearbeitung von
          Anfragen).
        </p>
        <p>
          Ihre Angaben werden in einer geschützten Datenbank gespeichert und nicht
          ohne Ihre Einwilligung an Dritte weiter­gegeben. Eine Löschung erfolgt,
          sobald die Daten für den Zweck der Anfrage nicht mehr erforderlich sind und
          keine gesetzlichen Aufbewahrungs­pflichten entgegen­stehen.
        </p>
      </section>

      <section>
        <h2>5. Hosting</h2>
        <p>
          Diese Website wird bei einem externen Dienst­leister gehostet. Die personen­bezogenen
          Daten, die auf dieser Website erfasst werden, werden auf den Servern des
          Hosters gespeichert. Der Hoster verarbeitet Ihre Daten ausschließlich zur
          Erfüllung seiner Leistungs­pflichten und folgt meinen Weisungen.
        </p>
        <p>
          Ein entsprechender Vertrag über die Auftrags­verarbeitung gemäß Art. 28 DSGVO
          liegt vor.
        </p>
      </section>

      <section>
        <h2>6. Cookies und Tracking</h2>
        <p>
          Diese Website setzt aktuell <strong>keine</strong> Tracking-, Marketing-
          oder Analyse-Cookies ein. Es findet keine Auswertung Ihres Nutzungs­verhaltens
          statt. Sollten künftig Cookies eingesetzt werden, die nicht technisch
          erforderlich sind, geschieht dies ausschließlich nach Ihrer ausdrücklichen
          Einwilligung gemäß § 25 Abs. 1 TDDDG i. V. m. Art. 6 Abs. 1 lit. a DSGVO.
        </p>
      </section>

      <section>
        <h2>7. Externe Schriftarten</h2>
        <p>
          Diese Website verwendet zur einheitlichen Darstellung Schriftarten der
          Anbieter Fontshare (Indian Type Foundry) sowie Google Fonts. Beim Aufruf
          dieser Website werden die benötigten Schriftarten vom jeweiligen
          Schriftarten-Dienst geladen. Hierbei kann die IP-Adresse Ihres Endgeräts an
          die Server des Anbieters übermittelt werden. Rechtsgrundlage ist Art. 6
          Abs. 1 lit. f DSGVO; das berechtigte Interesse besteht in der einheitlichen
          und ansprechenden Darstellung dieser Website.
        </p>
      </section>

      <section>
        <h2>8. Ihre Rechte</h2>
        <p>Ihnen stehen jederzeit folgende Rechte zu:</p>
        <ul>
          <li>Recht auf Auskunft (Art. 15 DSGVO)</li>
          <li>Recht auf Berichtigung (Art. 16 DSGVO)</li>
          <li>Recht auf Löschung (Art. 17 DSGVO)</li>
          <li>Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
          <li>Recht auf Daten­übertragbarkeit (Art. 20 DSGVO)</li>
          <li>Widerspruchsrecht gegen die Verarbeitung (Art. 21 DSGVO)</li>
          <li>Recht auf Widerruf einer erteilten Einwilligung (Art. 7 Abs. 3 DSGVO)</li>
        </ul>
        <p>
          Zur Geltendmachung Ihrer Rechte wenden Sie sich bitte an die oben genannte
          Kontakt­adresse.
        </p>
      </section>

      <section>
        <h2>9. Beschwerderecht bei der Aufsichts­behörde</h2>
        <p>
          Sie haben das Recht, sich bei einer Aufsichts­behörde über die Verarbeitung
          Ihrer personen­bezogenen Daten zu beschweren. Zuständig ist insbesondere:
        </p>
        <p>
          Der Hamburgische Beauftragte für Datenschutz und Informations­freiheit
          <br />
          Ludwig-Erhard-Straße 22, 7. OG
          <br />
          20459 Hamburg
          <br />
          Telefon: +49 40 428 54-4040
          <br />
          E-Mail: mailbox@datenschutz.hamburg.de
        </p>
      </section>

      <section>
        <h2>10. Automatisierte Entscheidungs­findung</h2>
        <p>
          Eine automatisierte Entscheidungs­findung einschließlich Profiling im Sinne
          von Art. 22 DSGVO findet nicht statt.
        </p>
      </section>

      <section>
        <h2>11. Aktualität und Änderung dieser Datenschutz­erklärung</h2>
        <p>
          Diese Datenschutz­erklärung ist aktuell gültig. Durch die Weiter­entwicklung
          dieser Website oder geänderte gesetzliche bzw. behördliche Vorgaben kann es
          erforderlich werden, diese Datenschutz­erklärung anzupassen. Die jeweils
          aktuelle Datenschutz­erklärung kann jederzeit auf dieser Seite abgerufen
          werden.
        </p>
      </section>

      <p className="text-xs text-[#4A4A52] pt-6 border-t border-black/10">
        Stand: {new Date().toLocaleDateString("de-DE", { year: "numeric", month: "long" })}
      </p>
    </LegalLayout>
  );
}
